import storage from 'util/storage'
import sharedStorage from 'util/sharedStorage'
import { buildUserForBugsnag } from 'util/bugsnag'
import { APP_BILLING_EXPIRED } from 'ducks/billing/types'
import { SIGNUP_SUCCESS } from 'subapps/onboarding/types'
import * as coreTypes from 'constants/action_types'
import * as types from './types'

const currentUser = storage.get('currentUser') || {}

const defaultState = {
  ...currentUser,
}
const reducers = {}

function getAvatarUrl(agent) {
  return agent && agent.avatar_url && !agent.avatar_url.match('missing.png')
    ? agent.avatar_url
    : null
}

function createUser(apiUser) {
  const newUser = { ...apiUser }
  newUser.avatarUrl = getAvatarUrl(apiUser)
  delete newUser.flags // NOTE (jscheel): These are stored in a duck
  storage.set('currentUser', newUser)
  storage.set('mx_access_token', newUser.chatAccessToken, {
    ignoreNamespace: true,
    asJson: false,
  })
  // We need it in IndexedDB so that the ServiceWorker can access it too.
  sharedStorage.setCurrentUserId(newUser.id)
  if (bugsnagClient) {
    bugsnagClient.user = buildUserForBugsnag(newUser)
  }
  return newUser
}

reducers[coreTypes.UPDATE_APP_DATA] = (state, action) => {
  const data = action.data
  const user = createUser(data.currentUser)
  return {
    ...state,
    ...user,
  }
}

reducers[APP_BILLING_EXPIRED] = (state, { data }) => {
  if (!data.user) {
    return state
  }
  return {
    ...state,
    ...createUser(data.user),
  }
}

reducers[coreTypes.LOGOUT] = () => {
  return { ...defaultState }
}

// Created as a helper to test UI for different agent types. E.g.
//
//   { type: 'CURRENT_USER_CHANGED', data: { role: 'admin'} }
//
reducers[types.CURRENT_USER_CHANGED] = (state, action) => {
  const agent = action.data
  return { ...state, ...agent }
}

reducers[SIGNUP_SUCCESS] = (state, action) => {
  const { user } = action.payload
  const newUser = createUser({ ...user })
  delete newUser.flags
  return {
    ...state,
    ...newUser,
  }
}

reducers[types.UPDATE_USER_PREFERENCES_REQUEST] = (
  state,
  { payload: { preferences } }
) => {
  return {
    ...state,
    preferences: {
      ...state.preferences,
      ...preferences,
    },
  }
}

reducers[types.UPDATE_CURRENT_USER_SUCCESS] = (state, { payload }) => {
  const { updateCurrentUser } = payload
  return {
    ...state,
    ...updateCurrentUser,
  }
}

export default function reducer(
  state = defaultState,
  action,
  sharedState = {}
) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action, sharedState)
  return state
}
